import React, {useCallback, useEffect, useRef, useState} from "react";
import {downloadPortalReceipt, listPortalReceipts} from "../api";
import type {PortalReceiptAudience} from "../api/merchantPortalPayin";
import type {PortalReceipt} from "../api";
import {useAuth} from "../auth";

export function PortalReceiptList({orderId, title = "Подтверждения мерчанта", audience = "merchant", refreshKey, hideEmpty = audience === "merchant"}: {orderId: string; title?: string; audience?: PortalReceiptAudience; refreshKey?: string | number; hideEmpty?: boolean}): JSX.Element | null {
  const {token} = useAuth();
  const [items, setItems] = useState<PortalReceipt[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState<string | null>(null);
  const requestSerial = useRef(0);
  const refresh = useCallback(() => {
    if (!token || !orderId || typeof listPortalReceipts !== "function") return;
    const serial = ++requestSerial.current;
    void listPortalReceipts(token, orderId, audience).then((r) => {
      if (serial !== requestSerial.current) return;
      setItems(r.items ?? []); setError(null);
    }).catch(() => {
      if (serial === requestSerial.current) setError("Не удалось загрузить подтверждения");
    });
  }, [audience, orderId, token]);
  useEffect(() => { refresh(); const timer = window.setInterval(refresh, 30_000); return () => window.clearInterval(timer); }, [refresh, refreshKey]);
  const open = async (item: PortalReceipt) => {
    if (!token || typeof downloadPortalReceipt !== "function") return;
    setBusy(item.receiptId);
    try { const blob = await downloadPortalReceipt(token, orderId, item.receiptId, audience); const url = URL.createObjectURL(blob); window.open(url, "_blank", "noopener,noreferrer"); window.setTimeout(() => URL.revokeObjectURL(url), 60_000); }
    catch { setError("Не удалось открыть подтверждение"); }
    finally { setBusy(null); }
  };
  // Блок без файлов не показывается (кроме разбора спора у админа). Попытка и
  // версия реквизитов мерчанту ничего не говорят — ему достаточно даты.
  const merchant = audience === "merchant";
  if (hideEmpty && items.length === 0 && !error) return null;
  return <section className="merchant-section-card" aria-label={title}>
    <div className="section-header merchant-section-header"><div><h2>{title}</h2>{!merchant && <span>Попытка и версия реквизитов сохраняются у каждого файла</span>}</div></div>
    {error && <div className="alert alert-warning" role="alert">{error}</div>}
    {items.length === 0 ? <div className="empty-state compact">Подтверждений пока нет.</div> : <ul className="merchant-receipt-list">{items.map((item) => <li key={item.receiptId}><div><strong>{item.authorRole === "merchant" ? "Мерчант" : item.authorRole}</strong><span>{merchant ? new Date(item.createdAt).toLocaleString() : `версия ${item.requisitesVersion} · попытка ${item.attemptId.slice(0, 8)} · ${new Date(item.createdAt).toLocaleString()}`}</span></div><button className="btn btn-ghost" type="button" onClick={() => void open(item)} disabled={busy === item.receiptId}>{busy === item.receiptId ? "Открываем…" : "Посмотреть"}</button></li>)}</ul>}
  </section>;
}
